import { render, staticRenderFns } from "./doctorInfo.vue?vue&type=template&id=1bc5fc04&scoped=true&"
import script from "./doctorInfo.vue?vue&type=script&lang=js&"
export * from "./doctorInfo.vue?vue&type=script&lang=js&"
import style0 from "./doctorInfo.vue?vue&type=style&index=0&id=1bc5fc04&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bc5fc04",
  null
  
)

export default component.exports